import React, { ButtonHTMLAttributes, forwardRef } from 'react';
import { composeBemClasses } from '../composeBemClasses';
import './Button.css';

export type ButtonVariant = 'primary' | 'secondary' | 'danger' | 'danger-outline' | 'close' | 'theme-toggle';
export type ButtonSize = 'small' | 'medium' | 'large' | 'action';

export interface ButtonProps extends ButtonHTMLAttributes<HTMLButtonElement> {
    variant?: ButtonVariant;
    size?: ButtonSize;
    fullWidth?: boolean;
    children: React.ReactNode;
}

const Button = forwardRef<HTMLButtonElement, ButtonProps>(({
    variant = 'primary',
    size = 'medium',
    fullWidth = false,
    className = '',
    disabled = false,
    children,
    ...props
}, ref) => {
    const combinedClassName = composeBemClasses(
        'btn',
        [variant, size],
        [fullWidth && 'full-width', disabled && 'disabled'],
        className
    );

    return (
        <button
            ref={ref}
            className={combinedClassName}
            disabled={disabled}
            {...props}
        >
            {children}
        </button>
    );
});

Button.displayName = 'Button';

export default Button;
